import { makePostRequest } from 'lib/axios';

const signUpWithGoogle = async (): Promise<{ message: string }> => {
  const url = `/auth/sign-up/google`;
  const response = await makePostRequest(url, {});
  return response.data.message;
};

export default signUpWithGoogle;
